
import types from './types';
import store from '../../../config/redux/store';
import { asyncGet } from '../../../config/rest/async-action-creator';

export default {
  fetchSeoData: (slug, customStore) => asyncGet(
    customStore || store,
    types.FETCH_SEO_DATA,
    `custom-page/${slug}`,
  ),
  fetchLexiqueTitle: (slug, customStore) => asyncGet(
    customStore || store,
    types.FETCH_LEXIQUE_TITLE,
    `custom-page/${slug}`,
  ),
  fetchLexiqueResults: (customStore) => asyncGet(
    customStore || store,
    types.FETCH_LEXIQUE_RESULTS,
    'custom-lexicon',
  ),
  fetchLexiqueSlug: (slug, customStore) => asyncGet(
    customStore || store,
    types.FETCH_LEXIQUE_SLUG,
    `custom-lexicon-slug/${slug}`,
  ),
};



// WEBPACK FOOTER //
// ./src/app/actions/lexique/index.js